module.exports = __webpack_public_path__ + "static/media/Aged_Receivable_Template_1.700832af.png";